import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/e7d3a66c-2a1f-4e79-8cdc-3604b9b5297c";
export const REGISTER_URL = "https://a.ntrk2.com/39d3d3d1-b2f6-4dd0-95ac-d159e91fabde";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://popph.kzw2a.com/download?openExternalBrowser=1&id=c10c0qstgaesf4j";

export * from "./codes";
export * from "./context";
